import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import {ApaleoConfig} from "crqlar-react-common/dist/models/integrations/apaleo/apaleo.config";
import ImportLogsTable from "../../common/ImportLogsTable";

interface Props {
    configData: UseEntityData<ApaleoConfig>
}

const Logs = ({configData}: Props) => (
    <ImportLogsTable
        configId={configData.item.id}
        tableId="system-apaleo-import-logs"
    />
);

export default Logs;
